// First option of a select meta sent by GET /metas (e.g. "session-discipline"), used as the
// form's default. The API keys these metas by their enum value ("flat-work", "jumping"…),
// so the key is returned as-is: parsing it as a number gave NaN/null and left the default empty.
export const firstMetaKey = (metas, metaKey) => {
    const options = metas?.[metaKey]
    if (!options || typeof options !== 'object' || Array.isArray(options)) return null

    const key = Object.keys(options).find((candidate) => candidate.trim() !== '')
    return key ?? null
}
